import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { AuthContext } from '../context'
import Button from './ui/Button'

const Header = () => {
  const { isAuthAdmin, setIsAuthAdmin, setAccessToken, roleName, setRoleName } = useContext(AuthContext)

  const logout = () => {
    sessionStorage.clear()
    setIsAuthAdmin(false)
    setAccessToken(null)
    setRoleName(null)
  }

  return (
    <div className="header">
        <div className="header__container container">
            <Link to='/' className="header__logo logo">
                Анкетирование ДГУ
            </Link>
            <nav className="header__menu menu">
                <div className="menu__body">
                    <ul className="menu__list">
                        <li className="menu__item">
                            <Link to='/' className="menu__link">Главная</Link>
                        </li>
                        <li className="menu__item">
                            <Link to='/information' href="#" className="menu__link">Информация</Link>
                        </li>
                        {
                            isAuthAdmin
                            ? 
                                <li className="menu__item">
                                    {
                                        (isAuthAdmin && roleName == "admin")
                                        && 
                                            <Link to='/admin' className='menu__link'>Личный кабинет</Link>
                                    }
                                    <Button type="button" className="menu__link" onClick={() => logout()}>Выход</Button>
                                </li>
                            :
                                <li className="menu__item">
                                    <Link to='/admin/login' className="menu__link">Вход</Link>
                                </li>
                        }
                    </ul>
                </div>
            </nav>
        </div>
    </div>
  )
}

export default Header